import { request } from '../../helpers/api/request';
import { FeedsContract } from '../../types/Endpoints/feeds';

export const getFeeds = async () => {
    const { data } = await request<FeedsContract>({
        url: 'admin/feeds',
    });

    return data;
};
